import { localeLink } from '@/utils/template';

// /promocode não é mais uma página: é o modal global
// (`components/promocode/Modal.vue`). Igual à roletinha, que também não tem tela
// própria — quem abre é a store, por cima de onde o jogador já está.
//
// Dois caminhos, porque "não navegar" só é possível quando existe um lugar onde
// ficar:
//
//  • Clique DENTRO do app (banner, card, menu, link do CMS): a navegação é
//    cancelada e o modal sobe por cima da tela atual. A rota nem chega a trocar.
//    Chamar a store aqui é seguro neste caminho: o app já está de pé, então o
//    estado de auth já foi resolvido.
//
//  • Entrada DIRETA na URL (favorito, e-mail, divulgação): não há tela anterior,
//    então cai na home com `?open=promocode` e o deep-link do layout sobe o modal
//    de lá. Aqui a store NÃO é chamada de propósito — o middleware roda antes do
//    plugin de auth, e ela mandaria pro login quem chegasse com a sessão ainda
//    carregando.
export default defineNuxtRouteMiddleware((to, from) => {
  const { getRouteBaseName } = useRoutes();

  if (getRouteBaseName(to) !== 'promocode') return;

  // `?promocode=XXX` (código pronto) viaja junto pro modal preencher o input.
  // Só a grafia minúscula: `?promoCode` é o cupom de afiliado, tratado no
  // `coupon.global`.
  const query = to.query.promocode;
  const code = typeof query === 'string' && query ? query : undefined;

  // `from.name` só existe quando já houve uma rota antes desta: numa entrada
  // direta o `from` é a rota-fantasma inicial, sem nome. O teste de path evita
  // cancelar a navegação de /promocode pra /promocode (recarregar o link estando
  // nele), que deixaria o jogador preso numa tela em branco.
  const isInAppNavigation = !!from.name && from.path !== to.path;

  if (isInAppNavigation) {
    if (import.meta.client) {
      usePromocodeStore().open({ code });
    }

    return abortNavigation();
  }

  return navigateTo(
    {
      path: localeLink('/'),
      query: {
        open: 'promocode',
        ...(code ? { promocode: code } : {}),
      },
    },
    { replace: true },
  );
});
